import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { DeleteDialog, DeleteDialogContext } from '.';
export const DeleteDialogContextWrapper = ({ children, onClose }) => {
    const [isClosing, setIsClosing] = React.useState(false);
    return (_jsxs(DeleteDialogContext.Provider, { value: { onClose, setIsClosing, isClosing }, children: [children, _jsx(DeleteDialog, { onClose, setIsClosing, isClosing })] }));
};
//# sourceMappingURL=delete-dialog-context-wrapper.js.map